export default __webpack_public_path__ + "static/media/ic-inspections-reports.c602e41c.svg";